import {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useState,
} from "react";
import { ACTION_TYPE } from "../utils/ActionType";
import { InitialValue, DataReducer } from "../reducer/DataReducer";
import {
  getAllVideos,
  getAllCategories,
  getLikedVideos,
  getPlaylistVideos,
  getWatchlaterVideos,
  getHistoryVideos,
} from "../Services/services";
import { useAuth } from "./auth-context";
const DataContext = createContext();

const DataProvider = ({ children }) => {
  const { token } = useAuth();
  const [state, dispatch] = useReducer(DataReducer, InitialValue);
  useEffect(() => {
    (async () => {
      const response = await getAllVideos();
      if (response.status === 200 || response.status === 201)
        dispatch({
          type: ACTION_TYPE.INITIAL_DATA,
          payload: response.data.videos,
        });
    })();
    (async () => {
      const response = await getAllCategories();
      if (response.status === 200 || response.status === 201)
        dispatch({
          type: ACTION_TYPE.CATEGORY,
          payload: response.data.categories,
        });
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (token) {
        const playlistRes = await getPlaylistVideos(token);
        const likedRes = await getLikedVideos(token);
        const watchlaterRes = await getWatchlaterVideos(token);
        const historyRes = await getHistoryVideos(token);

        dispatch({
          type: ACTION_TYPE.PLAYLIST,
          payload: playlistRes.data.playlists,
        });
        dispatch({ type: ACTION_TYPE.ADD_LIKED, payload: likedRes.data.likes });
        dispatch({
          type: ACTION_TYPE.ADD_WATCH,
          payload: watchlaterRes.data.watchlater,
        });
        dispatch({
          type: ACTION_TYPE.ADD_HISTORY,
          payload: historyRes.data.history,
        });
      } else dispatch({ type: ACTION_TYPE.LOGOUT, payload: InitialValue });
    })();
  }, [token]);

  const [sideBar, setSideBar] = useState(false);
  const [loader, setLoader] = useState(false);
  const sideBarHandler = () => {
    setSideBar((curr) => !curr);
  };

  return (
    <DataContext.Provider
      value={{ state, dispatch, sideBar, sideBarHandler, loader, setLoader }}
    >
      {children}
    </DataContext.Provider>
  );
};

const useData = () => useContext(DataContext);

export { DataProvider, useData };
